const knowledge = {
  path: '/knowledge',
  component: resolve => require(['../../../../pages/modules/knowledge'], resolve),
  meta: {
    requireAuth: true
  }
}

export default knowledge